<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "OutputLocations" });
import { fetchAddress } from "../../../address/services/api.js";
import { t } from "svelte-i18n";
export let addressKeys;
export let separator = "newline";
let countries = [];
const fetchAddresses = async (keys) => {
    const ADDRESSES = keys.map(async (key) => fetchAddress({ addressKey: key }));
    return await Promise.all(ADDRESSES);
};
const setLocations = async (keys) => {
    countries = [];
    if (keys === void 0) {
        return;
    }
    const ADDRESSES = await fetchAddresses(keys);
    const COUNTRY_CODES = ADDRESSES.map((address) => address.countryCode);
    const UNIQUE_CODES = [...new Set(COUNTRY_CODES)];
    countries = UNIQUE_CODES.filter((code) => code !== void 0).map((uniqueCode) => {
        const OCCURENCES = COUNTRY_CODES.filter((code) => code === uniqueCode).length;
        return { code: uniqueCode, count: OCCURENCES };
    });
};
$: void setLocations(addressKeys);
const showComma = (index) => separator === "comma" && index < countries.length - 1;
</script>

{#each countries as country, index}
    <img
        src = { `https://cdn.smatch.com/assets/flags/${ country.code }.svg` }
        alt = { $t(`global.country.${ country.code }`) }
    />
    { country.count } in { $t(`global.country.${ country.code }`) }{#if showComma(index)},&nbsp;{:else}<br/>{/if}
{/each}

<style>
    img {
        display: inline-block;
        height: 10px;
        vertical-align: baseline;
        margin-right: 2px;
    }</style>